const ERROR_NOT_FOUND = "Record not Found";
const ERROR_NOT_CONNECT = "Unable to connect to helper connector";
const ERROR_NOT_CORRECT = "Request not correct.";

const getHeaders = () => {
  let sessionID = localStorage?.getItem("site-helper-sessionid") || null;
  return sessionID
    ? {
        sessionID,
      }
    : null;
};
const reconnectInterval = 5000;

class APIWS {
  constructor(url) {
    this._event = {};
    this._reopen(url);
  }
  _reopen(url) {
    this._websocket = new WebSocket(url);
    this._isConnect = false;
    this._websocket.onopen = () => {
      this._isConnect = true;
    };
    this._websocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      this._event[data.function](data.result);
    };
    this._websocket.onclose = () => {
      // Действия при закрытии соединения
      setTimeout(() => {
        this._reopen(url);
      }, reconnectInterval); // Попытка восстановления
    };
  }
  _takeAfterCon(callback) {
    if (this._isConnect) {
      callback();
    } else {
      setTimeout(() => {
        this._takeAfterCon(callback);
      }, 1000);
    }
  }
  async send(data, callback = null) {
    try {
      let headers = getHeaders();
      let props = headers ? { ...data, headers: { ...headers } } : { ...data };
      this._takeAfterCon(() => {
        this._websocket.send(JSON.stringify({ ...props }));
      });
      if (callback) {
        this._event[data.function] = callback;
      }
    } catch (error) {
      console.log("error", error);
      return { error: "Error" };
    }
  }
  async addEvent(eventName, eventCallback) {
    this._takeAfterCon(() => {
      this._event[eventName] = eventCallback;
    });
  }
}

export const apiWS = (url) => new APIWS(url);
